import { Link } from 'react-router'
import { connect } from 'react-redux'
import styles from './style.css'
import {showModalOutletMobile} from 'actions'

class NavOutlet extends React.Component {
  render () {
    let {user, location} = this.props
    return (((user.is_owner || user.is_manager) && (location.pathname !== '/settings/billings')) &&
      <div className={`${styles['nav-outlet-wrapper']}`}>
        <Link className={styles['nav-outlet-link']} onClick={this._onClickOutletModal}>
          <div className='cell-outlet'>
            <div className='bar'>
              <p className={styles['text-block-center']}>{this._outletName()}&nbsp;</p>
            </div>
            <div className='baz'>
              <span className='caret' />
            </div>
          </div>
        </Link>
      </div>
    )
  }

  _outletName = () => {
    const {selectedOutletIds, outlets} = this.props
    if (selectedOutletIds.length > 1) {
      return 'All'
    } else {
      let label = 'Loading...'
      outlets.forEach((o) => {
        if (o.id === selectedOutletIds[0]) {
          label = o.name
        }
      })
      return label
    }
  }
  _onClickOutletModal = () => {
    this.props.dispatch(showModalOutletMobile(true))
  }
}

function select (state) {
  const {selectedOutletIds, outlets} = state.actionBar
  return {
    selectedOutletIds, outlets
  }
}

NavOutlet.propTypes = {
  outlets: React.PropTypes.array
}

export default connect(select)(NavOutlet)



// WEBPACK FOOTER //
// ./app/components/NavOutlet/NavOutlet.js